class AbstractEntityEditController extends AbstractController
	@register
	@inject '$timeout',
		'translate'
		'MessageTerminal'
		'ToastService'

	$onInit: ->
		super()

		if @save? and typeof @save == 'function'
			@MessageTerminal.onSave(@$scope,
				=>
					@mainCrud.saving = true
					do @save
			)

		if @delete? and typeof @delete == 'function'
			@MessageTerminal.onDelete(
				@$scope,
				=>
					@mainCrud.saving = true
					do @delete
			)

	deleteEntity: (repository, entity, title = @mainCrud.entityType, idAttribute = 'id', nameAttribute = 'name') ->
		return if @mainCrud.isNewEntity

		repository
			.delete entity[idAttribute]
			.then =>
				@afterDelete entity, title, nameAttribute
			.catch (response) =>
				@handleErrors response.data, title

				return Promise.reject(response)

	afterSave: (response, title = @mainCrud.entityType, isNewEntity = @mainCrud.isNewEntity, nameAttribute = 'name', message = null, updateName = true) ->
		data = if response.data? then response.data else response

		@mainCrud.parent_form.$setPristine()
		@mainCrud.parent_form.$setUntouched()

		if updateName
			@mainCrud.entityTitle = data[nameAttribute]

		message ?= if isNewEntity then 'alert.saved' else 'alert.updated'

		@ToastService.add(
			data[nameAttribute],
			@translate(title),
			@translate(message),
			'success'
		)

		# Give time for parent_form to set pristine state
		@$timeout(
			=>
				@MessageTerminal.afterSave isNewEntity, data
				@mainCrud.saving = false
				@mainCrud.isNewEntity = false
		)

	afterDelete: (entity, title = @mainCrud.entityType, nameAttribute = 'name', message = 'alert.deleted') ->
		@ToastService.add(
			entity[nameAttribute],
			@translate(title),
			@translate(message),
			'success'
		)
		@MessageTerminal.afterDelete entity

		@mainCrud.parent_form?.$setPristine()
		@mainCrud.parent_form?.$setUntouched()
		@mainCrud.saving = false

	handleErrors: (response, title = @mainCrud.entityType) ->
		super(response, title)

		@mainCrud.saving = false

	triggerFormChange: ->
		@mainCrud.parent_form.$setDirty()
